import {connect} from "react-redux";
import Image_Default from "../../images/man.png";
import { useNavigate } from "react-router-dom";

const Messages_Room_Window_Header = (props) => {
    const {id,firstName,lastName} = props.second_user;
    const navigate = useNavigate();
    const goToProfile = () => {
        if (id == props.user.id) {
            navigate("/profile")
        } else {
            navigate(`/profile/${props.second_user.id}`)
        }
    }
    return(
        <div onClick={goToProfile} className={`messages_room_window_header main_content_section_${props.color_background}`}>
            <img src={Image_Default} alt="User" className="messages_room_window_user_image" />
            <div className="messages_room_window_userinfo">
                <div className="messages_room_window_user_name">{firstName} {lastName}</div>
                <div className={`messages_room_window_user_online messages_room_content_${props.color_background}`}>Last seen recently</div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background,
        second_user: state.getSecondUser.second_user,
        user: state.getUser.user
    }
}
export default connect(mapStateToProps)(Messages_Room_Window_Header);